<div class="ra-survey-wrapper" >
    <header class='ra-header'>
        <a routerLink="/home" [queryParams]="{back:1}" class="ra-logo" title='回首頁'></a>
        <div class="ra-progress-wrapper ra-pc-only" data-target="idProgressBarPC">
            <a href="javascript:;" data-toggle ="idProgressBarPC" title='進度開關'>
                <app-ra-progress-btn step="step2"></app-ra-progress-btn>
            </a>
            <div class="ra-progress-modal" data-toggle="idProgressBarPC" >
                <div class="ra-progress-toggle">
                    <span class='ndbx-icon ra-icon-20 nx-icon--chevron-right'></span>
                </div>
                <app-ra-progress-body step="step2"></app-ra-progress-body>
            </div>
        </div>
        <a href="javascript:;" class="ra-mo-only" data-toggle="idProgressBarMo" title='進度開關'>
            <app-ra-progress-btn step="step2"></app-ra-progress-btn>
        </a>
    </header>

    <div class="ra-progress-wrapper-mo close" data-target="idProgressBarMo">
        <div class="ra-progress-bbl-mo" data-toggle="idProgressBarMo">
            <div class="ra-progress-close">
                <span class="ndbx-icon ra-icon-24 ra-icon--close"></span>
            </div>
            <app-ra-progress-body step="step2" [mobile]="true"></app-ra-progress-body>
        </div>
    </div>
    <!-- ra-STOP-SCROLLING:問卷頁鎖住scrollbar直到全部答完 -->
    <div class="ra-survey-main-wrapper jsChatMainWrapper ra-STOP-SCROLLING">
        <div class="jsWelcomeChat">
            <div class="ra-survey-container">
                <div class="ra-intro-wrapper">
                    <div data-id="idRoboadvGender" class="ra-intro-header ra-gender-girl">
                        <span data-id="idRoboadvGender" class="ra-avtr-gender ra-intro-gender ra-gender-girl"></span>
                        <h2 class="ra-intro-title">風險屬性問卷</h2>
                    </div>
                    <div class="ra-intro-body">
                        <p>下列各項問題係為協助本公司瞭解保戶之財務目標與風險容忍度，據以分析其需求與評估購買商品之適合度。</p>
                    </div>
                </div>
                <div class="ra-survey">
                    <div class="ra-survey-item is-hidden" data-id="Q1">
                        <span class="ra-survey-lock-hint is-hidden">請先作答上方題目</span>
                        <div class="ra-survey-icon" > </div>
                        <div class="ra-survey-content">
                            <h2>Q1 您 (要保人) 的年齡為：</h2>
                            <ul class='ra-survey-radiogroup'>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ1_A" (click)="score.Q1=5" name="idRadioGroupSurveyQ1" >
                                    <label for="idSurveyRiskQ1_A"><span class='ra-survey-radio-value'>A. 66歲(含)以上</span><span class='ra-survey-radio-score'>5分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ1_B" (click)="score.Q1=10" name="idRadioGroupSurveyQ1">
                                    <label for="idSurveyRiskQ1_B"><span class='ra-survey-radio-value'>B. 41歲~65歲</span><span class='ra-survey-radio-score'>10分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ1_C" (click)="score.Q1=15" name="idRadioGroupSurveyQ1">
                                    <label for="idSurveyRiskQ1_C"><span class='ra-survey-radio-value'>C. 40歲(含)以下</span><span class='ra-survey-radio-score'>15分</span></label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="ra-survey-item is-hidden" data-id="Q2">
                        <span class="ra-survey-lock-hint is-hidden">請先作答上方題目</span>
                        <div class="ra-survey-icon"> </div>
                        <div class="ra-survey-content">
                            <h2>Q2 風險承擔能力 (負年報酬率) (含價格與匯率波動)：</h2>
                            <ul class='ra-survey-radiogroup'>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ2_A" (click)="score.Q2=0" name="idRadioGroupSurveyQ2">
                                    <label for="idSurveyRiskQ2_A"><span class='ra-survey-radio-value'>A. 不能接受</span><span class='ra-survey-radio-score'>0分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ2_B" (click)="score.Q2=5" name="idRadioGroupSurveyQ2">
                                    <label for="idSurveyRiskQ2_B"><span class='ra-survey-radio-value'>B. -(0% ~ 10%)</span><span class='ra-survey-radio-score'>5分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ2_C" (click)="score.Q2=10" name="idRadioGroupSurveyQ2">
                                    <label for="idSurveyRiskQ2_C"><span class='ra-survey-radio-value'>C. -11%(含)以上</span><span class='ra-survey-radio-score'>10分</span></label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="ra-survey-item is-hidden" data-id="Q3">
                        <span class="ra-survey-lock-hint is-hidden">請先作答上方題目</span>
                        <div class="ra-survey-icon"> </div>
                        <div class="ra-survey-content">
                            <h2>Q3 投資因市場波動使得有所虧損時，可能採取哪ㄧ項處理方式？</h2>
                            <ul class='ra-survey-radiogroup'>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ3_A" (click)="score.Q3=0" name="idRadioGroupSurveyQ3">
                                    <label for="idSurveyRiskQ3_A"><span class='ra-survey-radio-value'>A. 虧損未達 6 個月時就考慮賣掉</span><span class='ra-survey-radio-score'>0分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ3_B" (click)="score.Q3=5" name="idRadioGroupSurveyQ3">
                                    <label for="idSurveyRiskQ3_B"><span class='ra-survey-radio-value'>B. 虧損已經 6 個月以上才考慮進行調整</span><span class='ra-survey-radio-score'>5分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ3_C" (click)="score.Q3=10" name="idRadioGroupSurveyQ3">
                                    <label for="idSurveyRiskQ3_C"><span class='ra-survey-radio-value'>C. 持有 1 年以上，因長期投資才是致勝關鍵</span><span class='ra-survey-radio-score'>10分</span></label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="ra-survey-item is-hidden" data-id="Q4">
                        <span class="ra-survey-lock-hint is-hidden">請先作答上方題目</span>
                        <div class="ra-survey-icon"> </div>
                        <div class="ra-survey-content">
                            <h2>Q4 財務目標：</h2>
                            <ul class='ra-survey-radiogroup'>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ4_A" (click)="score.Q4=0" name="idRadioGroupSurveyQ4">
                                    <label for="idSurveyRiskQ4_A"><span class='ra-survey-radio-value'>A. 避免資產損失</span><span class='ra-survey-radio-score'>0分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ4_B" (click)="score.Q4=5" name="idRadioGroupSurveyQ4">
                                    <label for="idSurveyRiskQ4_B"><span class='ra-survey-radio-value'>B. 資產穩定成長</span><span class='ra-survey-radio-score'>5分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ4_C" (click)="score.Q4=10" name="idRadioGroupSurveyQ4">
                                    <label for="idSurveyRiskQ4_C"><span class='ra-survey-radio-value'>C. 資產迅速成長</span><span class='ra-survey-radio-score'>10分</span></label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="ra-survey-item is-hidden" data-id="Q5">
                        <span class="ra-survey-lock-hint is-hidden">請先作答上方題目</span>
                        <div class="ra-survey-icon"> </div>
                        <div class="ra-survey-content">
                            <h2>Q5 投資商品如下跌或虧損超過 15% 以上，對財務的影響程度：</h2>
                            <ul class='ra-survey-radiogroup'>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ5_A" (click)="score.Q5=0" name="idRadioGroupSurveyQ5">
                                    <label for="idSurveyRiskQ5_A"><span class='ra-survey-radio-value'>A. 高</span><span class='ra-survey-radio-score'>0分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ5_B" (click)="score.Q5=5" name="idRadioGroupSurveyQ5">
                                    <label for="idSurveyRiskQ5_B"><span class='ra-survey-radio-value'>B. 中</span><span class='ra-survey-radio-score'>5分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ5_C" (click)="score.Q5=10" name="idRadioGroupSurveyQ5">
                                    <label for="idSurveyRiskQ5_C"><span class='ra-survey-radio-value'>C. 低</span><span class='ra-survey-radio-score'>10分</span></label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="ra-survey-item is-hidden" data-id="Q6">
                        <span class="ra-survey-lock-hint is-hidden">請先作答上方題目</span>
                        <div class="ra-survey-icon"> </div>
                        <div class="ra-survey-content">
                            <h2>Q6 自認具備金融專業能力：</h2>
                            <ul class='ra-survey-radiogroup'>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ6_A" (click)="score.Q6=0" name="idRadioGroupSurveyQ6">
                                    <label for="idSurveyRiskQ6_A"><span class='ra-survey-radio-value'>A. 不瞭解或僅初步了解部分金融商品</span><span
                                            class='ra-survey-radio-score'>0分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ6_B" (click)="score.Q6=5" name="idRadioGroupSurveyQ6">
                                    <label for="idSurveyRiskQ6_B"><span class='ra-survey-radio-value'>B. 普通，已有基本金融商品專業知識</span><span
                                            class='ra-survey-radio-score'>5分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ6_C" (click)="score.Q6=10" name="idRadioGroupSurveyQ6">
                                    <label for="idSurveyRiskQ6_C"><span class='ra-survey-radio-value'>C. 充分了解，主動掌握金融趨勢並進行投資組合規劃</span><span
                                            class='ra-survey-radio-score'>10分</span></label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="ra-survey-item is-hidden" data-id="Q7">
                        <span class="ra-survey-lock-hint is-hidden">請先作答上方題目</span>
                        <div class="ra-survey-icon"> </div>
                        <div class="ra-survey-content">
                            <h2>Q7 投資經驗(1)（可複選，但以分數較高者計分)</h2>
                            <ul class='ra-survey-radiogroup'>
                                <li>
                                    <input disabled class='ra-survey-radio' type="checkbox" id="idSurveyRiskQ7_A" (change)="toggleQ7($event,0)" name="idRadioGroupSurveyQ7">
                                    <label for="idSurveyRiskQ7_A"><span class='ra-survey-radio-value'>A. 存款、傳統型保險商品，或沒有任何經驗</span><span
                                            class='ra-survey-radio-score'>0分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="checkbox" id="idSurveyRiskQ7_B" (change)="toggleQ7($event,5)" name="idRadioGroupSurveyQ7">
                                    <label for="idSurveyRiskQ7_B"><span class='ra-survey-radio-value'>B. 債券、基金、投資型保險商品</span><span
                                            class='ra-survey-radio-score'>5分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="checkbox" id="idSurveyRiskQ7_C" (change)="toggleQ7($event,10)" name="idRadioGroupSurveyQ7">
                                    <label for="idSurveyRiskQ7_C"><span class='ra-survey-radio-value'>C. 股票、期貨或其他衍生性金融商品</span><span
                                            class='ra-survey-radio-score'>10分</span></label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="ra-survey-item is-hidden" data-id="Q8">
                        <span class="ra-survey-lock-hint is-hidden">請先作答上方題目</span>
                        <div class="ra-survey-icon"> </div>
                        <div class="ra-survey-content">
                            <h2>Q8 依據第7題的回答，您的投資經驗：</h2>
                            <ul class='ra-survey-radiogroup'>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ8_A" (click)="score.Q8=5" name="idRadioGroupSurveyQ8">
                                    <label for="idSurveyRiskQ8_A"><span class='ra-survey-radio-value'>A. 3個月以內</span><span
                                            class='ra-survey-radio-score'>5分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ8_B" (click)="score.Q8=10" name="idRadioGroupSurveyQ8">
                                    <label for="idSurveyRiskQ8_B"><span class='ra-survey-radio-value'>B. 3 個月～3 年</span><span
                                            class='ra-survey-radio-score'>10分</span></label>
                                </li>
                                <li>
                                    <input disabled class='ra-survey-radio' type="radio" id="idSurveyRiskQ8_C" (click)="score.Q8=15" name="idRadioGroupSurveyQ8">
                                    <label for="idSurveyRiskQ8_C"><span class='ra-survey-radio-value'>C. 3 年以上</span><span
                                            class='ra-survey-radio-score'>15分</span></label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="ra-survey-item is-hidden" data-id='DONE'>
                        <div class="ra-survey-icon no-bg">
                            <p>完成!</p>
                        </div>

                    </div>
                </div>
            </div>
            <div class="ra-survey-rst-container is-hidden">
                <div class="ra-survey-rst-people" [attr.data-surv-rst]="resultClass"></div>
                <div class="ra-survey-rst-wrapper">
                    <div class="ra-survey-user-rst" [attr.data-surv-rst]="resultClass">
                        <p>保戶的投資能力與風險承受度屬性總分為</p>
                        <!--<p>totalScore={{totalScore}}</p>-->
                        <p><span class="ra-survey-user-rst-score" [attr.data-surv-rst]="resultClass"></span>
                            <span class="ra-survey-user-rst-type" [attr.data-surv-rst]="resultClass"></span>
                        </p>
                    </div>
                    <div class="ra-survey-rst-table-wrapper">
                        <ul class="ra-survey-rst-table" [attr.data-surv-rst]="resultClass">
                            <li class='ra-survey-rst-title'>
                                <div class='ra-rst-score-title'>總分</div>
                                <div class='ra-rst-type-title'>財務目標暨投資風險屬性與商品之適合度及說明</div>
                            </li>
                            <li class='ra-survey-rst-data surv-rst-conserv'>
                                <div class='ra-rst-score'><p>25分<span class='ra-rst-changeline'><br></span><small>(含)以下</small></p><p><img class='' src="assets/img/chat/chart/robot_0.png" alt="保守小金"></p></div>
                                <div class='ra-rst-type '><p>保守型保戶</p><p class="ra-text-align-justify">保戶對投資的態度較為保守，無法承擔投資風險或可承擔投資風險很低，其投資組合僅適合經本公司評估風險等級為RR1之投資基金。</p></div>
                            </li>
                            <li class='ra-survey-rst-data surv-rst-steady'>
                                <div class='ra-rst-score'><p>26分 ～<span class='ra-rst-changeline'><br></span> 54分</p><p><img class='' src="assets/img/chat/chart/robot_2.png" alt="穩建小金"></p></div>
                                <div class='ra-rst-type '><p>穩健型保戶</p><p class="ra-text-align-justify">保戶對投資的態度較為穩健，可承擔部份程度的投資風險，其投資組合僅適合經本公司評估風險等級為RR1、 RR2、RR3 之投資基金。</p></div>
                            </li>
                            <li class='ra-survey-rst-data surv-rst-active'>
                                <div class='ra-rst-score'><p>55分<span class='ra-rst-changeline'><br></span><small>(含)以上</small></p><p><img class='' src="assets/img/chat/chart/robot_6.png" alt="積極小金"></p></div>
                                <div class='ra-rst-type '><p>積極型保戶</p><p class="ra-text-align-justify">保戶對投資的態度較為積極，願意承擔較高的投資風險以換取較大的報酬，其投資組合僅適合經本公司評估風險等級為RR1、RR2、RR3、 RR4、RR5之投資基金。</p></div>
                            </li>
                        </ul>
                        <p class="ra-survey-rst-note">★上述第 2 項問項之回答如果為「 A. 不能接受」，則不論總分為何，一律屬於「保守型保戶」。</p>
                        <div class="msg-bbl-btn-wrapper">
                            <a href="s2_2risktype.html" class="ra-btn ra-memo-full-btn ra-btn-primary "><span class="txt-btn-confirm">下一步</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="jsMsgBox ra-chat-anchor-wrapper jsChatAnchor" data-chat-group="idSummary-Ques">
        <button class="ra-chat-anchor" data-id='idAnchorTop' title='回頂端'>
            <span class="ndbx-icon ra-icon-24 ra-icon--arrow-up"></span>
        </button>
        <button class="ra-chat-anchor" data-id='idAnchorBottom' title='到底端'>
            <span class="ndbx-icon ra-icon-24 ra-icon--arrow-down"></span>
        </button>
    </div>
</div>
